import React from 'react';

import FormattedPrice from './FormattedPrice';

import '../IPosModal/components/itemInfo.scss';

const ItemInfo = ({orderItem, currentLanguageId = 2}) => {

  return (
    <div className={ 'item-info' }>
      <div className={ 'item-name-block' }>
        <div className={ 'item-name' }>
          {orderItem.menuItem.item_name}
        </div>
        <div className={ 'item-price' }>
          <FormattedPrice price={ orderItem.menuItem.web_price } />
        </div>
      </div>
      {(orderItem.menuItem.details_txt || orderItem.menuItem.details_eng_txt) && (
        <div className={ 'item-description' }>
          {currentLanguageId === 2 ? orderItem.menuItem.details_txt : orderItem.menuItem.details_eng_txt}
        </div>
      )}

    </div>
  );
};

export default ItemInfo;
